import { getRequest, postRequest, deleteRequest, putRequest } from "../api/apiService";

const QRTokenService = {
  /**
   * Generates a batch of unique QR tokens.
   * @param {number} count Number of tokens to generate.
   */
  generateTokens: async (count = 10) => {
    try {
      const response = await postRequest(`/api/qr-tokens/generate?count=${count}`);
      return response.data;
    } catch (error) {
      console.error("Error generating QR tokens:", error);
      throw error;
    }
  },

  /**
   * Verifies a token and returns its status.
   * @param {string} token Alphanumeric token.
   */
  verifyToken: async (token) => {
    try {
      const response = await getRequest(`/api/qr-tokens/verify/${token}`);
      return response.data;
    } catch (error) {
      console.error("Error verifying QR token:", error);
      throw error;
    }
  },

  /**
   * Marks a token as scanned to track recently scanned unused tokens.
   * @param {string} token Alphanumeric token.
   */
  markAsScanned: async (token) => {
    try {
      const response = await putRequest(`/api/qr-tokens/${token}/scanned`);
      return response.data;
    } catch (error) {
      console.error(`Error marking token as scanned ${token}:`, error);
      throw error;
    }
  },

  /**
   * Clears the scan status of a token.
   * @param {string} token Alphanumeric token.
   */
  clearScanStatus: async (token) => {
    try {
      const response = await deleteRequest(`/api/qr-tokens/${token}/scanned`);
      return response.data;
    } catch (error) {
      console.error(`Error clearing scan status for token ${token}:`, error);
      throw error;
    }
  },

  /**
   * Fetches all tokens in the system.
   */
  getAllTokens: async () => {
    try {
      const response = await getRequest("/api/qr-tokens/all");
      return response.data;
    } catch (error) {
      console.error("Error fetching all QR tokens:", error);
      throw error;
    }
  },

  /**
   * Deletes a specific QR token.
   * @param {string} token Alphanumeric token.
   */
  deleteToken: async (token) => {
    try {
      const response = await deleteRequest(`/api/qr-tokens/${token}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting token ${token}:`, error);
      throw error;
    }
  },

  /**
   * Deletes all unassigned QR tokens.
   */
  deleteUnassignedTokens: async () => {
    try {
      const response = await deleteRequest("/api/qr-tokens/unassigned");
      return response.data;
    } catch (error) {
      console.error("Error deleting unassigned tokens:", error);
      throw error;
    }
  },

  /**
   * Resolves a potentially shortened URL to its original HomeBox URL.
   * @param {string} url The URL to resolve.
   */
  resolveUrl: async (url) => {
    try {
      const response = await getRequest(`/api/qr-tokens/resolve?url=${encodeURIComponent(url)}`);
      return response.data;
    } catch (error) {
      console.error("Error resolving URL:", error);
      throw error;
    }
  }
};

export default QRTokenService;
